import {Component, Inject, Input, OnInit, Optional, ViewChild} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslocoService } from '@ngneat/transloco';
import { RegioLockService } from 'app/modules/admin/services/regio-lock.service';
import { sub } from 'date-fns';
import { ChartComponent } from 'ng-apexcharts';

@Component({
    selector: 'app-sensor-values',
    templateUrl: './sensor-values.component.html',
    styleUrls: ['./sensor-values.component.scss'],
})
export class SensorValuesComponent implements OnInit {
    @ViewChild('chart') chart: ChartComponent;

    @Input()
    locationId: string;
    public chartOptions: any;
    chartLoaded: boolean = false;
    loadFailed: boolean = false;
    // Datenquelle der Kurve (vom Server gewählt): UniFi-Protect-Sensor vor RegioLock
    sourceLabel: string = '';

    constructor(
        private regioLockService: RegioLockService,
        private transloco: TranslocoService,
        // Als Dialog geöffnet kommt die Standort-Id über die Dialog-Daten (Inputs greifen dort nicht)
        @Optional() @Inject(MAT_DIALOG_DATA) private dialogData: any,
        // Nur gesetzt, wenn die Komponente als Dialog geöffnet wurde (X-Button in der Kopfzeile)
        @Optional() public dialogRef: MatDialogRef<SensorValuesComponent>,
    ) {}

    updateTimeRage(days: number) {
        // endDate = jetzt, startDate = x Tage davor (war vertauscht → leere Abfrage)
        const endDate = new Date();
        const startDate = sub(endDate, { days: days });
        this.updateData(startDate, endDate, this.locationId);
    }

    updateData(startDate: Date, endDate: Date, storageLocationId: string) {
        this.loadFailed = false;
        this.regioLockService
            .getClimate(startDate.toISOString(), endDate.toISOString(), storageLocationId)
            .subscribe({
                next: (result: any) => {
                    const data = result?.values;
                    this.sourceLabel = result?.sourceLabel || '';
                    if (!Array.isArray(data) || data.length === 0) {
                        this.loadFailed = true;
                        return;
                    }
                    let temp = [];
                    let humidity = [];

                    data.forEach((element: any) => {
                        let date = new Date(element.time).getTime();
                        temp.push([date, element.temp]);
                        humidity.push([date, element.hum]);
                    });

                    this.chartOptions.series = [
                        {
                            name: this.transloco.translate('unit-temperature'),
                            data: temp,
                        },
                        {
                            name: this.transloco.translate('unit-humidity'),
                            data: humidity,
                        },
                    ];

                    this.chartLoaded = true;
                },
                error: () => {
                    this.loadFailed = true;
                },
            });
    }

    ngOnInit(): void {
        this.locationId = this.locationId || this.dialogData?.locationId;
        this.chartOptions = {
            series: [
                {
                    name: this.transloco.translate('unit-temperature'),
                    data: [],
                },
                {
                    name: this.transloco.translate('unit-humidity'),
                    data: [],
                },
            ],
            chart: {
                animations: {
                    speed: 400,
                    animateGradually: {
                        enabled: false,
                    },
                },
                fontFamily: 'inherit',
                foreColor: 'inherit',
                width: '100%',
                height: '100%',
                type: 'area',
                toolbar: {
                    show: false,
                },
                zoom: {
                    enabled: false,
                },
            },
            colors: ['#f7b52b', '#0da1d7'],
            dataLabels: {
                enabled: false,
            },
            fill: {
                colors: ['#f7b52b'],
            },
            grid: {
                show: false,
                borderColor: '#334155',
                padding: {
                    top: 10,
                    bottom: 0,
                    left: 0,
                    right: 0,
                },
                position: 'back',
                xaxis: {
                    lines: {
                        show: true,
                    },
                },
            },
            stroke: {
                width: 2,
            },
            tooltip: {
                followCursor: true,
                theme: 'dark',
                x: {
                    format: 'MMM dd, yyyy HH:mm',
                },
                y: {
                    formatter: (value: number): string => `${value}`,
                },
            },
            xaxis: {
                axisBorder: {
                    show: false,
                },
                axisTicks: {
                    show: false,
                },
                crosshairs: {
                    stroke: {
                        color: '#475569',
                        dashArray: 0,
                        width: 2,
                    },
                },
                labels: {
                    offsetY: 0,
                    style: {
                        colors: '#ffffff',
                    },
                },
                tickAmount: 20,
                tooltip: {
                    enabled: false,
                },
                type: 'datetime',
            },
            yaxis: {
                axisTicks: {
                    show: false,
                },
                axisBorder: {
                    show: false,
                },
                min: (min): number => min - 30,
                max: (max): number => max + 40,
                tickAmount: 5,
                show: false,
            },
        };

        this.updateTimeRage(7);
    }
}
